<template>


<div class="row" v-if="this.$gate.areFirmaSelectata()"> <!-- <div class="row" v-if="$gate.isAdmin()"> -->

  <div class="toolbar py-6">
      <div class="container-fluid d-flex align-items-center">
          <div class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                  <span class="h-20px border-gray-200 border-start mx-3"></span>
                  <ol class="breadcrumb breadcrumb-dot text-muted fs-6 fw-semibold">
                      <li class="breadcrumb-item pe-3"><a @click="$router.go(-1)" style="cursor: pointer;" class="pe-3">Înapoi</a></li>
                      <li class="breadcrumb-item pe-3 text-muted">Adaugă factură proformă</li>
                  </ol>
                  <span class="h-20px border-gray-200 border-start mx-3"></span>
          </div>
      </div>
  </div>
		
  <div v-if="!this.$gate.firmaActiva()" class="alert alert-warning text-center my-10">
    <h4 class="mb-2"><i class="fas fa-exclamation-triangle text-warning me-2"></i> Firma nu este activă</h4>
    <p>Nu poți accesa facturile până ce firma nu este validată.</p>
  </div>

  <div class="content d-flex flex-column flex-column-fluid" v-if="this.$gate.firmaActiva()">
      <AdaugaFacturaProforma
          v-if="afiseazaFormularFactura"
          v-model:afiseazaLista="afiseazaTabel"
          @renuntaFactura="handleRenuntaFactura"
      />
      <!-- Facturare Table Card -->
      <div class="container-fluid mb-12" v-if="afiseazaTabel">
          <div class="card card-flush">
              <div class="card-header align-items-center py-5 gap-2 gap-md-5">
                  <div class="card-title">
                      <div class="d-flex align-items-center position-relative my-1">
                          <h3 class="card-title">Lista facturi proforme</h3>
                      </div>
                  </div>
                  <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
                      <div class="input-group w-250px">
                          
                      </div>
                      <div class="w-100 mw-150px">
                          
                      </div>
                      <a href="#" class="btn btn-primary" @click="afiseazaFormularFactura = true;">Adaugă factură proformă</a>
                      
                  </div>
              </div>
              <div class="card-body pt-0">
                  <div id="tabel_fp_container" class="table table-bordered table-striped">
                      <div class="table-responsive">
                          <!-- Update table class and layout to restore Excel-like appearance -->
                          <table class="table table-bordered table-striped nowrap" role="grid" id="tabel_fp" >
                              <thead>
                                  <tr class="text-uppercase fw-bold">
                                      <th class="text-center" style="width:32px">
                                        <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex">
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :checked="selectAllVisibleChecked"
                                            @change="onToggleSelectAllVisible($event)"
                                          />
                                        </div>
                                      </th>
                                      <th></th>
                                      <th>Data</th>
                                      <th>Nr. doc.</th>
                                      <th>Client</th>
                                      <th>Valoare</th>
                                      <th>TVA</th>
                                      <th>Total</th>
                                      <th>Stare</th>
                                      <th>Sold</th>
                                      <th>Scadenta</th>
                                      <th>TVA-I</th>
                                      <th>Agent</th>
                                      <th>Cont debit</th>
                                      <th>Acțiuni</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <template v-for="(factura) in facturi_emise" :key="factura.id">
                                    <tr :class="`row-factura-${factura.id}`">
                                      <td class="text-center">
                                        <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex">
                                          <input
                                            class="form-check-input row-select"
                                            type="checkbox"
                                            :checked="isSelected(factura.id)"
                                            @change="onToggleSelect(factura.id, $event)"
                                          />
                                        </div>
                                      </td>
                                      <td class="details-control text-center" style="cursor: pointer;" @click="toggleFacturaDetails(factura)">
                                        <i class="fas fa-chevron-down" :class="{ 'rotate-up': expandedRows.includes(factura.id) }"></i>
                                      </td>
                                      <td>{{ $filters.formatDate(factura.data_doc) || '/' }}</td>
                                      <td :data-order="Number(factura.nr_doc) || 0">
                                          {{ factura.sd_serie }}{{ factura.nr_doc }}
                                      </td>
                                      <td>{{ factura.c_denumire || '/' }}</td>
                                      <td class="text-end">{{ $filters.toCurrency(factura.iesiri_date_valoare) || '0.00' }}</td>
                                      <td class="text-end">{{ $filters.toCurrency(factura.iesiri_date_tva) || '0.00' }}</td>
                                      <td class="text-end">{{ $filters.toCurrency(factura.iesiri_date_total) || '0.00' }}</td>
                                      <td>
                                        <span v-if="Number(factura.facturare) === 1" class="badge bg-success">Transformată în factură</span>
                                        <span v-else class="badge bg-secondary">Proformă</span>
                                      </td>
                                      <td class="text-end">{{ $filters.toCurrency(factura.isf_sold) || '0.00' }}</td>
                                      <td>{{ $filters.formatDate(factura.data_scadenta) || '/' }}</td>
                                      <td class="text-center">
                                        <div class="form-check form-check-custom form-check-success form-check-solid d-inline-flex align-items-center mb-0">
                                          <input
                                            class="form-check-input"
                                            type="checkbox"
                                            :checked="factura.tva_incasare"
                                            disabled
                                          />
                                        </div>
                                      </td>
                                      <td>{{ factura.agent || '-' }}</td>
                                      <td>{{ factura.cont_debit || '-' }}</td>
                                      <td class="text-nowrap">
                                          <div class="d-inline-block" :ref="`rowMenuRef-${factura.id}`">
                                            <button
                                              type="button"
                                              class="btn btn-sm btn-primary rotate"
                                              data-kt-menu-trigger="click"
                                              data-kt-menu-placement="bottom-start"
                                              data-kt-menu-offset="0, 6"
                                            >
                                              Acțiuni
                                              <span class="fas fa-chevron-down rotate-180 ms-2 me-0"></span>
                                            </button>
                                            <div
                                              class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold py-2 w-200px"
                                              data-kt-menu="true"
                                            >
                                              <div class="menu-item px-3">
                                                <a class="menu-link px-3" @click="toggleFacturaDetails(factura); hideKtMenu(rowMenuRefName(factura.id))">
                                                  Vezi detalii produse
                                                </a>
                                              </div>
                                              <div class="menu-item px-3">
                                                <a class="menu-link px-3" @click="copyPdfLink(factura.id); hideKtMenu(rowMenuRefName(factura.id))">
                                                  Copiază link PDF
                                                </a>
                                              </div>
                                              <div class="menu-item px-3" v-if="Number(factura.facturare) !== 1">
                                                <a class="menu-link px-3" @click="creeazaFacturaDinProforma(factura); hideKtMenu(rowMenuRefName(factura.id))">
                                                  Creează factură
                                                </a>
                                              </div>
                                              <div class="menu-item px-3" v-else>
                                                <span class="menu-link px-3 disabled text-muted">Factură creată</span>
                                              </div>
                                            </div>
                                            <button class="btn btn-sm btn-outline-primary" @click="descarcaFacturaPDF(factura.id)">
                                              📄 Generează PDF
                                            </button>
                                          </div>
                                      </td>
                                    </tr>
                                  </template>
                              </tbody>
                          </table>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- End Facturare Table Card -->
  </div>

</div>
  <!-- E-Fact Popup -->
  <div class="row" v-if="!this.$gate.areFirmaSelectata()">
      <div class="card-body p-9" >
          <div class="notice d-flex bg-light-danger rounded border-warning border border-dashed p-6">
              <i class="ki-duotone ki-information fs-2tx text-danger me-4">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
              </i>
              <div class="d-flex flex-stack flex-grow-1">
                  <div class="fw-semibold">
                      <h4 class="text-gray-900 fw-bold">Nu aveti o firma selectata</h4>
                      <div class="fs-6 text-gray-700">In cazul in care aveti o firma deja adaugata, trebuie sa selectati firma folosind butonul "Schimba firma" aflat in partea de sus.<br/>
                          In cazul in care nu aveti nicio firma adaugata, trebuie sa adaugati o firma noua pentru a putea utiliza modulul de facturare.
                      </div>
                  </div>
                  <div class="d-flex align-items-center gap-2 gap-lg-3">
                      <router-link to="/firmele-mele" class="btn btn-sm fw-bold btn-success">
                          Adaugă firmă
                      </router-link>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>


<script>
import $ from 'jquery'
if (!window.$) window.$ = $
if (!window.jQuery) window.jQuery = $

import DataTable from 'datatables.net-bs5'
import 'datatables.net-bs5/css/dataTables.bootstrap5.css'
// Attach the jQuery plugin if not already registered (v2 ESM)
if (typeof $.fn.dataTable === 'undefined') {
  DataTable(window, $)
}

import moment from "moment";
import draggable from 'vuedraggable';
import { createApp } from 'vue';
import FacturaChild from '../FacturaProforma/FacturaProformaChild.vue';
import AdaugaFacturaProforma from './AdaugaFacturaProforma.vue';
    
    export default {
          components: {
            moment: moment,
            draggable,
            AdaugaFacturaProforma,
          },
    data () {
        return {
            setari_select2: {
                theme: "bootstrap",
                placeholder: "Selectează din listă",
                width: "100%",
            },
            clienti: [],
            editmode: false,
            facturi_emise: [],
            afiseazaInformatii: false,
            afiseazaFormularFactura: false,
            afiseazaTabel: true,
            expandedRows: [],
            produseFacturi: {},
            selectedIds: [],
            selectAllVisibleChecked: false,
        }
    },

    methods:{
        descarcaFacturaPDF(id) {
          const url = `/api/facturare_proforme/utils/pdf/fi/${id}`;
          window.open(url, '_blank');
        },
        copyPdfLink(id) {
          try {
            const url = `${location.origin}/api/facturare_proforme/utils/pdf/fi/${id}`;
            if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
              navigator.clipboard.writeText(url).then(() => {
                console.log('Link PDF copiat în clipboard');
              }).catch(() => {
                window.prompt('Copiază manual linkul PDF:', url);
              });
            } else {
              window.prompt('Copiază manual linkul PDF:', url);
            }
          } catch (e) {
            console.warn('Nu s-a putut copia linkul PDF:', e);
          }
        },
        initKTMenus() {
          try {
            if (window.KTMenu && typeof window.KTMenu.createInstances === 'function') {
              window.KTMenu.createInstances();
            } else if (window.KTMenu && typeof window.KTMenu.init === 'function') {
              window.KTMenu.init();
            }
          } catch (e) {
            console.warn('KTMenu init failed:', e);
          }
        },
        selectedRows() {
          // comoditate: lista obiectelor factura selectate
          const ids = new Set(this.selectedIds);
          return this.facturi_emise.filter(f => ids.has(f.id));
        },
        hideKtMenu(refName) {
          try {
            let root = this.$refs[refName];
            if (!root) return;
            // If it's an array (v-for refs), take the first element
            if (Array.isArray(root)) root = root[0];
            // If it's a Vue component, use its $el
            const rootEl = root && root.$el ? root.$el : root;
            // Ensure we have a real DOM element before querying
            if (!rootEl || typeof rootEl.querySelector !== 'function') return;

            const menuEl = rootEl.querySelector('[data-kt-menu="true"]');
            if (!menuEl) return;

            if (window.KTMenu && typeof window.KTMenu.getInstance === 'function') {
              let inst = window.KTMenu.getInstance(menuEl);
              if (!inst && typeof window.KTMenu === 'function') {
                // instantiate if not already
                inst = new window.KTMenu(menuEl);
              }
              if (inst && typeof inst.hide === 'function') inst.hide();
            } else {
              // Fallback: hide by class/style if KTMenu API not available
              menuEl.classList.remove('show');
              menuEl.style.display = 'none';
            }
          } catch (e) {
            console.warn('hideKtMenu error:', e);
          }
        },
        rowMenuRefName(id) {
          return `rowMenuRef-${id}`;
        },
        isSelected(id) {
          return this.selectedIds.includes(id);
        },
        onToggleSelect(id, evt) {
          const checked = !!evt.target.checked;
          if (checked) {
            if (!this.selectedIds.includes(id)) this.selectedIds.push(id);
          } else {
            this.selectedIds = this.selectedIds.filter(x => x !== id);
            this.selectAllVisibleChecked = false;
          }
        },
        getVisibleFacturaIds() {
          try {
            const table = $('#tabel_fp').DataTable();
            const nodes = table.rows({ search: 'applied', page: 'current' }).nodes();
            const ids = [];
            $(nodes).each(function () {
              const cls = this.className || '';
              const m = cls.match(/row-factura-(\d+)/);
              if (m && m[1]) ids.push(Number(m[1]));
            });
            return ids;
          } catch { return []; }
        },
        onToggleSelectAllVisible(evt) {
          const checked = !!evt.target.checked;
          this.selectAllVisibleChecked = checked;
          const ids = this.getVisibleFacturaIds();
          if (checked) {
            ids.forEach(id => { if (!this.selectedIds.includes(id)) this.selectedIds.push(id); });
          } else {
            this.selectedIds = this.selectedIds.filter(x => !ids.includes(x));
          }
        },
        produsePeFactura(id) {
            return this.produseFacturi[id] || [];
        },
        formatFacturaChildRow(factura, produse) {
            const wrapper = document.createElement('div');
            const app = createApp(FacturaChild, { factura, produse });
            app.mount(wrapper);
            return wrapper;
        },
        async incarcaProduseFactura(id) {
            try {
                const response = await axios.get('/api/facturare_proforme/incarcaFacturi/'+id);
                this.produseFacturi = {
                  ...this.produseFacturi,
                  [id]: response.data
                };
                // poți salva datele într-un obiect separat dacă vrei
                // this.produseFacturiNou = { ...this.produseFacturiNou, [id]: response.data };
            } catch (error) {
                console.error(`Eroare la încărcarea produselor pentru factura ${id}:`, error);
            }
        },
        incarcaTabelFacturare() {
          axios.get('/api/facturare_proforme/incarcaFacturi')
            .then((response) => {
              this.facturi_emise = response.data;
              this.$nextTick(() => {
                // custom EU date ordering only once
                if (!$.fn.dataTable.ext.type.order['date-eu-pre']) {
                  $.fn.dataTable.ext.type.order['date-eu-pre'] = function (date) {
                    if (!date) return 0
                    const parts = String(date).split('.')
                    if (parts.length !== 3) return 0
                    return Date.parse(`${parts[2]}-${parts[1]}-${parts[0]}`) // YYYY-MM-DD
                  }
                }

                const $table = $('#tabel_fp')
                // destroy safely if already initialized
                if ($.fn.dataTable.isDataTable($table)) {
                  $table.DataTable().clear().destroy()
                }

                const vm = this
                const table = $table.DataTable({
                  pageLength: 15,
                  lengthChange: true,
                  lengthMenu: [[15, 25, 50, 100], [15, 25, 50, 100]],
                  stateSave: true,
                  stateDuration: -1, // keep indefinitely (localStorage)
                  columnDefs: [
                    { targets: 1, responsivePriority: 1 },
                    { targets: 2, type: 'date-eu' },
                  ],
                  order: [[2, 'desc'], [3, 'desc']],
                  language: { url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json' },
                  paging: true,
                  pagingType: 'full_numbers',
                  ordering: true,
                  info: true,
                  searching: true,
                  responsive: false,
                  createdRow: function (row, data, dataIndex) {
                    const factura = vm.facturi_emise[dataIndex]
                    if (factura && factura.id) {
                      $(row).addClass(`row-factura-${factura.id}`)
                    } else {
                      console.warn('Factura ID not found for dataIndex:', dataIndex, data)
                    }
                  },
                })

                // re‑hook KTMenu after draws
                this.$nextTick(() => this.initKTMenus())
                table.on('draw.dt', () => {
                  this.$nextTick(() => this.initKTMenus())
                })
              })
            })
        },
        toggleFacturaDetails(factura) {
            const $t = $('#tabel_fp');
            if (!$t.length || !$.fn.dataTable.isDataTable($t)) return;
            const table = $t.DataTable();
            const tr = $(`.row-factura-${factura.id}`);
            const row = table.row(tr);

            if (row.child.isShown()) {
              row.child.hide();
              tr.removeClass('shown');
              this.expandedRows = this.expandedRows.filter(id => id !== factura.id);
            } else {
              if (!this.produseFacturi[factura.id]) {
                this.incarcaProduseFactura(factura.id).then(() => {
                  const produse = this.produseFacturi[factura.id] || [];
                  row.child(this.formatFacturaChildRow(factura, produse)).show();
                  tr.addClass('shown');
                  if (!this.expandedRows.includes(factura.id)) {
                    this.expandedRows.push(factura.id);
                  }
                });
              } else {
                const produse = this.produseFacturi[factura.id] || [];
                row.child(this.formatFacturaChildRow(factura, produse)).show();
                tr.addClass('shown');
                if (!this.expandedRows.includes(factura.id)) {
                  this.expandedRows.push(factura.id);
                }
              }
            }
        },
        async creeazaFacturaDinProforma(factura) {
          try {
            if (!factura || !factura.id) return;

            // Confirmare cu atenționare privind seria folosită
            if (typeof Swal !== 'undefined' && Swal && typeof Swal.fire === 'function') {
              const confirm = await Swal.fire({
                title: 'Creezi factura direct?',
                html: `
                  <p>Această acțiune va genera factura imediat, fără editare.</p>
                  <p style="color: red; font-weight: bold;">Aceasta va folosi ultima plajă de serii folosită!</p>
                `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Da, creează',
                cancelButtonText: 'Anulează'
              });
              if (!confirm.isConfirmed) return;
            }

            // UI state pentru rând
            this.$set ? this.$set(factura, '_creating', true) : (factura._creating = true);

            const { data } = await axios.post('/api/facturare/creeazaDinProforma', { id_proforma: factura.id });

            // Toast cu serie/număr
            if (typeof toast !== 'undefined' && toast && typeof toast.fire === 'function') {
              toast.fire({
                icon: 'success',
                title: `Factura ${data?.serie_doc ? '#' + data.serie_doc + '/' : '#'}${data?.nr_doc ?? ''} a fost creată.`,
              });
            }

            // Marchează local proforma ca facturată și notifică lista
            factura.facturare = 1;
            if (typeof emitter !== 'undefined' && emitter && typeof emitter.emit === 'function') {
              emitter.emit('AfterCreate');
            }
          } catch (e) {
            console.error('Eroare la crearea facturii din proformă:', e);
            if (typeof toast !== 'undefined' && toast && typeof toast.fire === 'function') {
              toast.fire({ icon: 'error', title: 'Eroare la crearea facturii din proformă.' });
            }
          } finally {
            this.$set ? this.$set(factura, '_creating', false) : (factura._creating = false);
          }
        },
        handleRenuntaFactura() {
            this.afiseazaFormularFactura = false;
            this.afiseazaTabel = true;
            //this.incarcaTabelFacturare(); // dacă vrei să reîncarci și datele
        },
    },
    computed: {
      expandedFacturi() {
          return this.facturi_emise.filter(factura => this.expandedRows.includes(factura.id));
      },
    },
    created(){
        this.incarcaTabelFacturare();
        emitter.on('AfterCreate',() => { 
            $('#tabel_fp').DataTable().destroy();
            this.incarcaTabelFacturare();
        });
    },
    mounted() {
      document.addEventListener('click', this.handleDocumentClick);
      this.$nextTick(() => this.initKTMenus());
    },
    beforeUnmount() {
      document.removeEventListener('click', this.handleDocumentClick);
    },
    activated() {
      //this.$nextTick(() => this.initKTMenus());
    },
    
}
    
    </script>
    
    
<style lang="scss" scoped>


    .icon-mare {
        font-size: 24px
    }

    #tabel_fp {
        font-size: 14px;
    }

    #tabel_fp th,
    #tabel_fp td {
        padding: 4px 6px !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    #tabel_fp th:first-child,
    #tabel_fp td:first-child { width: 32px; }

    .fas {
        transition: transform 0.3s ease;
    }

    .rotate-up {
        transform: rotate(180deg);
    }
    .rotate-down {
        transform: rotate(0deg);
    }

    #tabel_fp tbody tr {
        border-bottom: 2px solid #bdbdbd;
    }

    #tabel_fp tbody tr:not(.child):hover {
        background-color: #d4f8dd !important;
    }

    #tabel_fp tbody tr.shown {
        background-color: #e0ffe0 !important; /* Verde deschis sau orice vrei */
    }



    /* Tighter cells for selection + TVA-I columns (1st and 12th) */
    #tabel_fp th:nth-child(1),
    #tabel_fp td:nth-child(1),
    #tabel_fp th:nth-child(12),
    #tabel_fp td:nth-child(12) {
      padding-left: 2px !important;
      padding-right: 2px !important;
      width: 28px; /* keep narrow */
    }

    /* Remove default Bootstrap .form-check extra spacing inside table */
    #tabel_fp .form-check {
      padding-left: 0;   /* kill left indent */
      min-height: 0;     /* prevent tall rows */
      margin: 0;         /* no outer margin */
    }
    #tabel_fp .form-check-input {
      position: static;  /* avoid absolute offsets */
      margin: 0;         /* center via parent text-center */
      line-height: 1;    /* compact */
    }
    


/* Make Acțiuni column fit button size */
#tabel_fp th:last-child,
#tabel_fp td:last-child {
  width: 1%;
  white-space: nowrap;
}
#tabel_fp td:last-child .btn {
  min-width: auto;
}

</style>



